import { useId } from 'react'

import { AutoFormInputComponentProps } from '../ui/auto-form'
import { FormControl, FormDescription, FormItem } from '../ui/form'
import { FormFieldWrapper } from './FormFieldWrapper'
import { FormTextarea } from './FormTextarea'

export function AutoFormTextarea({ label, isRequired, fieldConfigItem, fieldProps }: AutoFormInputComponentProps) {
  const fallBackName = useId()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const name = fieldProps.name ?? fallBackName

  return (
    <FormItem>
      <FormControl>
        <FormFieldWrapper
          type={fieldConfigItem.fieldType ?? 'text'}
          label={label}
          required={isRequired}
          {...fieldProps}
          name={name}
          className="h-auto pt-2.5"
        >
          <FormTextarea
            type={fieldConfigItem.fieldType ?? 'text'}
            label={label}
            required={isRequired}
            {...fieldProps}
            name={name}
          />
        </FormFieldWrapper>
      </FormControl>
      {fieldConfigItem.description && <FormDescription>{fieldConfigItem.description}</FormDescription>}
    </FormItem>
  )
}
